import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { Alerts } from "../alerts/Alerts.tsx";

const RouteClosureDetail = ({ permissionsListData, boxesReassignDelivery, tableTitle, status = "Delivery" }) => {

    const {
        warningAlertRequest
    } = Alerts();

    return <>
        {boxesReassignDelivery?.length > 0 && (
            <Box mt={4}>
                <h3 style={{ marginTop: '20px', fontWeight: 'bold' }}>{tableTitle} (Total: {boxesReassignDelivery.length})</h3>
                <Box style={{ maxHeight: 180, overflowY: 'auto', border: '1px solid #ccc', borderRadius: 4 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><b>{status} ID</b></TableCell>
                                <TableCell><b>Cobrado por Driver</b></TableCell>
                                {/* <TableCell><b>Monto Recibido a Driver</b></TableCell> */}
                                <TableCell><b>Pagado hasta hoy</b></TableCell>
                                <TableCell><b>Monto a Cobrar</b></TableCell>
                                <TableCell><b>Estado de registro</b></TableCell>
                                <TableCell><b>Reasignado/Reasignar</b></TableCell>
                                <TableCell><b>Opciones</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {boxesReassignDelivery.map((box, index) => (
                                <TableRow key={index}>
                                    <TableCell>{box.correlative}</TableCell>
                                    <TableCell>{parseFloat(box.cash || 0).toFixed(2)}</TableCell>
                                    {/* <TableCell>{parseFloat(box.payed || 0).toFixed(2)}</TableCell> */}
                                    <TableCell>{parseFloat(box.total_payed || 0).toFixed(2)}</TableCell>
                                    <TableCell>{parseFloat(box.delivery_cost || 0).toFixed(2)}</TableCell>
                                    <TableCell
                                    style={{
                                            fontWeight: 'bold',
                                            color: box.record_status ==='ACTIVO' ? 'green' : 'red',
                                        }}
                                        >
                                            {box.record_status === 'ACTIVO' ? 'ACTIVO': 'ANULADO'}</TableCell>
                                    <TableCell
                                        align="right"
                                        style={{
                                            fontWeight: 'bold',
                                            color:
                                                (box.delivery_cost ?? 0) - (box.payed ?? 0) <= 0
                                                    ? 'green'
                                                    : box.reassigned
                                                        ? 'blue'
                                                        : 'orange',
                                        }}
                                    >
                                        {box.record_status === 'ACTIVO' ?
                                            ((box.delivery_cost ?? 0) - (box.payed ?? 0) <= 0
                                                ? 'Pago completado'
                                                : box.reassigned
                                                    ? 'Reprogramado'
                                                    : 'Con saldo')
                                            : ""
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            color="secondary"
                                            size="small"
                                            variant="contained"
                                            onClick={() => {
                                                let url = '';
                                                if (box.status === 1) {
                                                    if (permissionsListData.includes(28)) {
                                                        url = "/DeliveryForm?id=" + box.correlative;
                                                    } else {
                                                        warningAlertRequest('No cuenta con permisos para editar Delivery');
                                                        return;
                                                    }
                                                } else {
                                                    if (permissionsListData.includes(29)) {
                                                        url = "/PickupForm?id=" + box.correlative;
                                                    } else {
                                                        warningAlertRequest('No cuenta con permisos para editar Pickup');
                                                        return;
                                                    }
                                                }
                                                // Abre en una nueva ventana/pestaña
                                                window.open(url, '_blank');
                                            }}
                                        >
                                            <Box sx={{ ml: "5px" }}>
                                                Ver caja
                                            </Box>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        )}
    </>
}

export default RouteClosureDetail;